import { BlockComponentModel } from '@/cms/types/blok-component';
import { StrapiThemes } from '@/theme/themeProviderUtils';

import { BlockWrapper } from '@/cms/BlockWrapperDC';
import ImageStrapi, {
  ImageStrapiProps,
} from '@/decodo/components/atoms/Image/ImageStrapi';
import { LinkButtonStrapiProps } from '@/decodo/components/atoms/LinkButton/LinkStrapi';
import RichTextFieldStrapi, {
  RichTextFieldStrapiProps,
} from '@/decodo/components/atoms/RichTextField/RichTextFieldStrapi';

import { SECTION_NAMES } from '@/integrations/trackingScripts/constants';
import Banner from './index';

export interface BannerStrapiProps {
  image: ImageStrapiProps;
  title: string;
  theme?: StrapiThemes;
  description: RichTextFieldStrapiProps;
  direction: 'column' | 'row' | null;
  buttons?: LinkButtonStrapiProps[];
  countdownExpiry: string | null;
}

export function BannerStrapi({
  block,
  ...rest
}: BlockComponentModel<BannerStrapiProps>) {
  const { image, title, description, countdownExpiry, direction } = block;

  return (
    <BlockWrapper {...rest} data-tracker-section={SECTION_NAMES.BANNER}>
      <div>
        <Banner
          button={block.buttons?.[0]}
          description={
            description ? <RichTextFieldStrapi block={description} /> : ''
          }
          title={title}
          direction={direction}
          image={
            <ImageStrapi
              inner={{ classNames: { image: 'w-9' } }}
              block={{ ...image }}
            />
          }
          countdownExpiry={countdownExpiry}
        />
      </div>
    </BlockWrapper>
  );
}
